export default __webpack_public_path__ + "static/media/noResults.4506babb.png";